import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Mail, Phone, MapPin, ExternalLink, Copy, CheckCircle, Building2, Globe, Crown, Users, Search } from "lucide-react";
import { Button } from "../components/ui/button";
import { InternalNav } from "../components/InternalNav";
import { useState } from "react";

// FRANCHISING NAZIONALI
const franchising = [
  {
    name: "Tecnocasa",
    type: "Leader Italia",
    agencies: "1.000+ agenzie",
    email: "info@tecnocasa.it",
    phone: "02 66951",
    website: "tecnocasa.it",
    logo: "🏠"
  },
  {
    name: "Gabetti",
    type: "Dal 1950",
    agencies: "700+ agenzie",
    email: "info@gabetti.it",
    phone: "06 68891",
    website: "gabetti.it",
    logo: "🏢"
  },
  {
    name: "Re/Max Italia",
    type: "Network Globale",
    agencies: "400+ agenzie",
    email: "info@remax.it",
    phone: "02 54107860",
    website: "remax.it",
    logo: "🔴"
  },
  {
    name: "Coldwell Banker",
    type: "Premium",
    agencies: "150+ agenzie",
    email: "info@coldwellbanker.it",
    phone: "02 87244700",
    website: "coldwellbanker.it",
    logo: "🔵"
  },
  {
    name: "Tempocasa",
    type: "Franchising",
    agencies: "600+ punti vendita",
    email: "info@tempocasa.it",
    phone: "02 26951",
    website: "tempocasa.it",
    logo: "⏰"
  },
  {
    name: "Toscano",
    type: "Immobiliare",
    agencies: "300+ agenzie",
    email: "info@immobiliaretoscano.it",
    phone: "02 66101691",
    website: "immobiliaretoscano.it",
    logo: "🏛️"
  }
];

// LUXURY
const luxury = [
  {
    name: "Lionard Luxury Real Estate",
    location: "Firenze, Milano, Roma, Napoli, Venezia",
    email: "info@lionard.com",
    phone: "+39 055 054 8100",
    website: "lionard.com",
    specialty: "Immobili di pregio"
  },
  {
    name: "Engel & Völkers",
    location: "Milano, Roma, Firenze, Lago di Como",
    email: "milano@engelvoelkers.com",
    phone: "+39 06 45548120",
    website: "engelvoelkers.com",
    specialty: "Luxury internazionale"
  },
  {
    name: "Italy Sotheby's Realty",
    location: "Milano, Palermo",
    email: "info@sothebysrealty.it",
    phone: "+39 02 8707 8300",
    website: "italy-sothebysrealty.com",
    specialty: "Proprietà esclusive"
  },
  {
    name: "Christie's Real Estate",
    location: "Network Italia",
    email: "italy@christiesrealestate.com",
    phone: "-",
    website: "christiesrealestate.com",
    specialty: "Immobili d'arte"
  },
  {
    name: "Coldwell Banker Global Luxury",
    location: "Milano, Roma, Firenze",
    email: "luxury@coldwellbanker.it",
    phone: "+39 02 87244700",
    website: "coldwellbankerluxury.it",
    specialty: "Residenze esclusive"
  },
  {
    name: "John Taylor",
    location: "Milano",
    email: "milano@john-taylor.com",
    phone: "-",
    website: "john-taylor.it",
    specialty: "Immobili prestigio"
  }
];

// PORTALI ONLINE
const portali = [
  {
    name: "Idealista",
    type: "Portale Leader",
    contact: "02 36580315",
    email: "pro@idealista.it",
    website: "idealista.it/nuovo-professionale",
    note: "Partnership B2B disponibili"
  },
  {
    name: "Immobiliare.it",
    type: "Unicorno Italiano",
    contact: "02 87159500",
    email: "business@immobiliare.it",
    website: "immobiliare.it",
    note: "56% traffico italiano"
  },
  {
    name: "Casa.it",
    type: "Gruppo Idealista",
    contact: "02 36580315",
    email: "info@casa.it",
    website: "casa.it",
    note: "Integrato con Idealista"
  },
  {
    name: "Homepal",
    type: "Agenzia Online",
    contact: "-",
    email: "info@homepal.it",
    website: "homepal.it",
    note: "Partner Intesa Sanpaolo"
  }
];

// TOSCANA LOCALE
const toscana = [
  { name: "Valdelsa Immobiliare", location: "Colle di Val d'Elsa", responsible: "Gianni Terrosi", email: "info@valdelsaimmobiliare.it", phone: "0577 923291" },
  { name: "Max Abramo RE", location: "San Gimignano", responsible: "Max Abramo", email: "info@maxabramo.com", phone: "335 1676914" },
  { name: "Studio Montagliari", location: "Panzano in Chianti", responsible: "Claudia Voss", email: "cvoss@toskana.it", phone: "335 361872" },
  { name: "Geko Immobiliare", location: "San Gimignano", responsible: "-", email: "info@gekoimmobiliare.com", phone: "331 2222793" },
  { name: "Immobiliare Chianti", location: "Radda in Chianti", responsible: "Antonio Lapucci", email: "info@immobiliarechianti.it", phone: "-" },
  { name: "Betti Toscana", location: "Siena", responsible: "-", email: "info@bettitoscana.it", phone: "0577 935236" },
  { name: "Valdelsa Real Estate", location: "Poggibonsi", responsible: "-", email: "valdelsarealestate@gmail.com", phone: "366 5999797" },
  { name: "Knight Frank Tuscany", location: "Radda in Chianti", responsible: "-", email: "-", phone: "0577 738908" },
];

const emailTemplate = `Gentile Responsabile,

sono Riccardo Rossi, Fotografo Google Street View Certificato dal 2016.

Vi propongo una partnership vantaggiosa per i Virtual Tour 360° dei vostri immobili:

PACCHETTO START: Virtual Tour a €99
PACCHETTO PLUS: Virtual Tour a €299
PACCHETTO ROOFTOP: Virtual Tour a €599 (Formazione IN REGALO)

VANTAGGI:
✓ Pubblicazione su Google Maps (aumenta visibilità +87%)
✓ Pagamento in 3 rate PayPal (TAEG 0%)
✓ Detraibile 100% come spesa pubblicitaria
✓ Timewarp Hyperlapse IN REGALO in tutti i pacchetti

Esempi live: https://schedabusiness.it

Resto a disposizione per una demo.

Cordiali saluti,
Riccardo Rossi
WhatsApp: +39 327 383 9782
schedabusiness.it`;

export default function AgenciesToscana() {
  const navigate = useNavigate();
  const [copiedEmail, setCopiedEmail] = useState(null);
  const [showTemplate, setShowTemplate] = useState(false);
  const [activeTab, setActiveTab] = useState("franchising");

  const copyEmail = (email) => {
    if (email && email !== "-") {
      navigator.clipboard.writeText(email);
      setCopiedEmail(email);
      setTimeout(() => setCopiedEmail(null), 2000);
    }
  };

  const copyAllEmails = () => {
    const allEmails = [
      ...franchising.map(a => a.email),
      ...luxury.map(a => a.email),
      ...portali.map(a => a.email),
      ...toscana.map(a => a.email)
    ].filter(e => e && e !== "-").join(", ");
    navigator.clipboard.writeText(allEmails);
    setCopiedEmail("all");
    setTimeout(() => setCopiedEmail(null), 2000);
  };

  const tabs = [
    { id: "franchising", label: "Franchising Nazionali", icon: Building2, count: franchising.length },
    { id: "luxury", label: "Luxury", icon: Crown, count: luxury.length },
    { id: "portali", label: "Portali Online", icon: Globe, count: portali.length },
    { id: "toscana", label: "Toscana", icon: MapPin, count: toscana.length },
  ];

  return (
    <div className="min-h-screen bg-[#F8F9FA] py-8 px-4 sm:px-6" data-testid="agencies-page">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <motion.div 
          className="mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-[#5F6368] hover:text-[#202124] mb-6 transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla Home
          </button>

          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <h1 className="text-3xl sm:text-4xl font-semibold text-[#202124] mb-2">
                Agenzie Immobiliari{" "}
                <span className="text-[#4285F4]">Italia</span>
              </h1>
              <p className="text-[#5F6368]">
                Database completo: <span className="font-semibold">{franchising.length + luxury.length + portali.length + toscana.length}</span> contatti 
                | Franchising, Luxury, Online, Locali
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <span className="px-3 py-1 rounded-full bg-[#E6F4EA] text-[#34A853] font-medium">
                Pacchetti da €99
              </span>
            </div>
          </div>
        </motion.div>

        {/* Actions */}
        <motion.div 
          className="flex flex-wrap gap-3 mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <Button 
            onClick={copyAllEmails}
            className="bg-[#4285F4] text-white hover:bg-[#1A73E8] rounded-full"
            data-testid="copy-all-emails"
          >
            {copiedEmail === "all" ? <CheckCircle className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}
            {copiedEmail === "all" ? "Copiate!" : "Copia tutte le email"}
          </Button>
          <Button 
            variant="outline"
            className="border-[#DADCE0] text-[#202124] hover:bg-white rounded-full"
            onClick={() => setShowTemplate(!showTemplate)}
          >
            <Mail className="w-4 h-4 mr-2" />
            {showTemplate ? "Nascondi" : "Template Email"}
          </Button>
        </motion.div>

        {/* Email Template */}
        {showTemplate && (
          <motion.div 
            className="mb-6 p-5 rounded-2xl bg-white border border-[#DADCE0] shadow-sm"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
          >
            <h3 className="text-[#202124] font-semibold mb-3 flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#4285F4]" />
              Template Email Proposta B2B
            </h3>
            <pre className="text-[#5F6368] text-sm whitespace-pre-wrap font-mono bg-[#F8F9FA] p-4 rounded-xl overflow-x-auto border border-[#DADCE0] max-h-64 overflow-y-auto">
              {emailTemplate}
            </pre>
            <Button 
              className="mt-3 bg-[#E8F0FE] text-[#4285F4] hover:bg-[#D2E3FC] rounded-full"
              onClick={() => {
                navigator.clipboard.writeText(emailTemplate);
                setCopiedEmail("template");
                setTimeout(() => setCopiedEmail(null), 2000);
              }}
            >
              {copiedEmail === "template" ? <CheckCircle className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}
              {copiedEmail === "template" ? "Copiato!" : "Copia Template"}
            </Button>
          </motion.div>
        )}

        {/* Tabs */}
        <div className="flex flex-wrap gap-2 mb-6 bg-white p-2 rounded-2xl border border-[#DADCE0]">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                activeTab === tab.id 
                  ? "bg-[#4285F4] text-white" 
                  : "text-[#5F6368] hover:bg-[#F8F9FA]"
              }`}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
              <span className={`px-2 py-0.5 rounded-full text-xs ${
                activeTab === tab.id ? "bg-white/20" : "bg-[#F8F9FA]"
              }`}>
                {tab.count}
              </span>
            </button>
          ))}
        </div>

        {/* FRANCHISING */}
        {activeTab === "franchising" && (
          <motion.div 
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {franchising.map((agency, i) => (
              <div
                key={i}
                className="p-5 rounded-2xl bg-white border border-[#DADCE0] hover:shadow-lg transition-all"
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-2xl">{agency.logo}</span>
                      <h3 className="font-semibold text-[#202124]">{agency.name}</h3>
                    </div>
                    <p className="text-xs text-[#5F6368]">{agency.type} • {agency.agencies}</p>
                  </div>
                  <a href={`https://${agency.website}`} target="_blank" rel="noopener noreferrer" className="p-2 hover:bg-[#F8F9FA] rounded-full">
                    <ExternalLink className="w-4 h-4 text-[#5F6368]" />
                  </a>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button
                    onClick={() => copyEmail(agency.email)}
                    className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs text-[#5F6368] hover:bg-[#E8F0FE] hover:text-[#4285F4] transition-all"
                  >
                    {copiedEmail === agency.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                    {agency.email}
                  </button>
                  {agency.phone && (
                    <a href={`tel:${agency.phone}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs text-[#5F6368] hover:bg-[#E6F4EA] hover:text-[#34A853]">
                      <Phone className="w-3 h-3" />
                      {agency.phone}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </motion.div>
        )}

        {/* LUXURY */}
        {activeTab === "luxury" && (
          <motion.div 
            className="grid sm:grid-cols-2 gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {luxury.map((agency, i) => (
              <div
                key={i}
                className="p-5 rounded-2xl bg-gradient-to-br from-[#FEF7E0] to-white border border-[#FBBC05]/30 hover:shadow-lg transition-all"
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <Crown className="w-4 h-4 text-[#FBBC05]" />
                      <h3 className="font-semibold text-[#202124]">{agency.name}</h3>
                    </div>
                    <p className="text-xs text-[#5F6368]">{agency.location}</p>
                    <p className="text-xs text-[#FBBC05] font-medium mt-1">{agency.specialty}</p>
                  </div>
                  <a href={`https://${agency.website}`} target="_blank" rel="noopener noreferrer" className="p-2 hover:bg-white/50 rounded-full">
                    <ExternalLink className="w-4 h-4 text-[#5F6368]" />
                  </a>
                </div>
                <div className="flex flex-wrap gap-2">
                  {agency.email && agency.email !== "-" && (
                    <button
                      onClick={() => copyEmail(agency.email)}
                      className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs text-[#5F6368] hover:bg-[#E8F0FE] hover:text-[#4285F4] transition-all"
                    >
                      {copiedEmail === agency.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                      {agency.email}
                    </button>
                  )}
                  {agency.phone && agency.phone !== "-" && (
                    <a href={`tel:${agency.phone}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs text-[#5F6368] hover:bg-[#E6F4EA] hover:text-[#34A853]">
                      <Phone className="w-3 h-3" />
                      {agency.phone}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </motion.div>
        )}

        {/* PORTALI ONLINE */}
        {activeTab === "portali" && (
          <motion.div 
            className="grid sm:grid-cols-2 gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {portali.map((portal, i) => (
              <div
                key={i}
                className="p-5 rounded-2xl bg-gradient-to-br from-[#E8F0FE] to-white border border-[#4285F4]/30 hover:shadow-lg transition-all"
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <Globe className="w-4 h-4 text-[#4285F4]" />
                      <h3 className="font-semibold text-[#202124]">{portal.name}</h3>
                    </div>
                    <p className="text-xs text-[#4285F4] font-medium">{portal.type}</p>
                    <p className="text-xs text-[#5F6368] mt-1">{portal.note}</p>
                  </div>
                  <a href={`https://${portal.website}`} target="_blank" rel="noopener noreferrer" className="p-2 hover:bg-white/50 rounded-full">
                    <ExternalLink className="w-4 h-4 text-[#5F6368]" />
                  </a>
                </div>
                <div className="flex flex-wrap gap-2">
                  {portal.email && (
                    <button
                      onClick={() => copyEmail(portal.email)}
                      className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs text-[#5F6368] hover:bg-[#E8F0FE] hover:text-[#4285F4] transition-all"
                    >
                      {copiedEmail === portal.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                      {portal.email}
                    </button>
                  )}
                  {portal.contact && portal.contact !== "-" && (
                    <a href={`tel:${portal.contact}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/80 text-xs text-[#5F6368] hover:bg-[#E6F4EA] hover:text-[#34A853]">
                      <Phone className="w-3 h-3" />
                      {portal.contact}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </motion.div>
        )}

        {/* TOSCANA */}
        {activeTab === "toscana" && (
          <motion.div 
            className="grid sm:grid-cols-2 gap-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {toscana.map((agency, i) => (
              <div
                key={i}
                className="p-5 rounded-2xl bg-white border border-[#DADCE0] hover:shadow-md transition-all"
              >
                <div className="mb-3">
                  <h3 className="font-semibold text-[#202124] mb-1">{agency.name}</h3>
                  <div className="flex items-center gap-2 text-xs text-[#5F6368]">
                    <MapPin className="w-3 h-3" />
                    {agency.location}
                  </div>
                  {agency.responsible && agency.responsible !== "-" && (
                    <p className="text-xs text-[#4285F4] font-medium mt-1">{agency.responsible}</p>
                  )}
                </div>
                <div className="flex flex-wrap gap-2">
                  {agency.email && agency.email !== "-" && (
                    <button
                      onClick={() => copyEmail(agency.email)}
                      className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs text-[#5F6368] hover:bg-[#E8F0FE] hover:text-[#4285F4] transition-all"
                    >
                      {copiedEmail === agency.email ? <CheckCircle className="w-3 h-3 text-[#34A853]" /> : <Mail className="w-3 h-3" />}
                      {agency.email}
                    </button>
                  )}
                  {agency.phone && agency.phone !== "-" && (
                    <a href={`tel:${agency.phone}`} className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#F8F9FA] text-xs text-[#5F6368] hover:bg-[#E6F4EA] hover:text-[#34A853]">
                      <Phone className="w-3 h-3" />
                      {agency.phone}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </motion.div>
        )}

        {/* Stats */}
        <motion.div 
          className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <div className="p-4 rounded-2xl bg-[#E8F0FE] text-center">
            <div className="text-2xl font-bold text-[#4285F4]">{franchising.length}</div>
            <div className="text-xs text-[#5F6368]">Franchising Nazionali</div>
          </div>
          <div className="p-4 rounded-2xl bg-[#FEF7E0] text-center">
            <div className="text-2xl font-bold text-[#FBBC05]">{luxury.length}</div>
            <div className="text-xs text-[#5F6368]">Agenzie Luxury</div>
          </div>
          <div className="p-4 rounded-2xl bg-[#E6F4EA] text-center">
            <div className="text-2xl font-bold text-[#34A853]">{portali.length}</div>
            <div className="text-xs text-[#5F6368]">Portali Online</div>
          </div>
          <div className="p-4 rounded-2xl bg-[#FCE8E6] text-center">
            <div className="text-2xl font-bold text-[#EA4335]">{toscana.length}</div>
            <div className="text-xs text-[#5F6368]">Toscana Locale</div>
          </div>
        </motion.div>

        {/* Back CTA */}
        <motion.div 
          className="mt-10 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className="flex flex-wrap gap-3 justify-center">
            <Button 
              onClick={() => navigate("/email")}
              variant="outline"
              className="border-[#EA4335] text-[#EA4335] hover:bg-[#FCE8E6] rounded-full"
            >
              <Mail className="w-4 h-4 mr-2" />
              Email Template
            </Button>
            <Button 
              onClick={() => navigate("/roadmap")}
              variant="outline"
              className="border-[#34A853] text-[#34A853] hover:bg-[#E6F4EA] rounded-full"
            >
              Roadmap Commerciale
            </Button>
          </div>

          <div className="mt-6 border-t border-[#DADCE0] pt-4">
            <InternalNav />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
